function filterPayments(payments) {
  // eslint-disable-next-line no-unused-expressions
  const paymentsCopy = payments.length > 0
    ? payments.filter(pay => pay.status === 'VP' || pay.status === 'NE') : [];

  return paymentsCopy.filter((pay) => {
    const date1 = new Date();
    const date2 = new Date(pay.expected_to);
    const diffTime = (date1 > date2) ? (Math.abs(date1 - date2) * (-1)) : Math.abs(date1 - date2);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return (diffDays) >= -6;
  });
}


export default filterPayments;
